import {
  getThreadCategoryTag,
  isR18ThreadTagName,
  type ThreadTag,
} from "@/entities/thread";

/** カタログカードに表示する現行16分類のカテゴリとR18を取り出す。 */
export function getCatalogCategoryTags(
  tags: readonly ThreadTag[],
): ThreadTag[] {
  const categoryTag = getThreadCategoryTag(tags);
  const r18Tag = tags.find((tag) => isR18ThreadTagName(tag.name));
  return [categoryTag, r18Tag].filter(
    (tag): tag is ThreadTag => tag !== undefined,
  );
}
